module.exports = __webpack_public_path__ + "img/earbuds.e0ab28a0.png";